@if (mapsLoaded()) {
  @if (options()) {
    <google-map [height]="height" width="100%" [options]="options()">
      <map-marker [position]="latLong()" />
    </google-map>
  }
}
